import React from 'react';
import {Text} from "@chakra-ui/react";

const AddressMultiline = ({ address }) => {
  return (
    <>
      {Object.values(address.multiline).map((line, index) => (
        <Text key={index} className="inspection__address" mb={0}>
          {line}
        </Text>
      ))}
    </>
  );
}

export default AddressMultiline;
